export const SMART_OAUTH_ERROR_MESSAGES = {
  FHIR_SOURCE_NOT_FOUND: "FHIR source not found for the provided URL",
  PROVIDER_NOT_CONFIGURED: "Provider not configured",
  AUTHORIZATION_CODE_REQUIRED: "Authorization code is required",
  STATE_NOT_FOUND: "OAuth state not found",
  INVALID_STATE: "Invalid OAuth state",
  STATE_EXPIRED: "OAuth state has expired",
  PRIVATE_KEY_NOT_FOUND: "Private key not found for provider",
  CLIENT_SECRET_NOT_FOUND: "Client secret not found for provider",
  CODE_VERIFIER_NOT_FOUND: "Code verifier not found in state",
  UNKNOWN_AUTH_MODE: "Unknown authentication mode",
  PATIENT_INFO_NOT_FOUND: "Could not retrieve patient information",
  TARGET_USER_NOT_FOUND: "Target user not found",
  ACCOUNT_ALREADY_LINKED:
    "This EHR account is already linked to another user. Please unlink from the other account first.",
  ACCOUNT_EXISTS:
    "This EHR account is already linked to a user. Please sign in with your existing credentials.",
  USER_CREATION_FAILED: "Failed to create user",
  USER_NOT_FOUND: "User not found",
  JWKS_NOT_FOUND: "No JWKS available for provider",
  OAUTH_CALLBACK_FAILED:
    "We couldn't complete the connection. Please try again.",
} as const;

export type SmartOAuthErrorCode = keyof typeof SMART_OAUTH_ERROR_MESSAGES;
export type SmartOAuthUrlErrorCode = Lowercase<SmartOAuthErrorCode>;

export function isSmartOAuthErrorCode(
  code: string,
): code is SmartOAuthErrorCode {
  return code.toUpperCase() in SMART_OAUTH_ERROR_MESSAGES;
}

export function toSmartOAuthUrlErrorCode(
  code: SmartOAuthErrorCode,
): SmartOAuthUrlErrorCode {
  return code.toLowerCase() as SmartOAuthUrlErrorCode;
}

export function getSmartOAuthErrorMessage(code: SmartOAuthErrorCode): string {
  return SMART_OAUTH_ERROR_MESSAGES[code];
}

export function getSmartOAuthErrorMessageFromUrlCode(
  code: string,
): string | null {
  const normalizedCode = code.toUpperCase();
  if (!isSmartOAuthErrorCode(normalizedCode)) {
    return null;
  }

  return getSmartOAuthErrorMessage(normalizedCode);
}
